import makeSlice from '@web/slices/voucher/sliceMaker'

const slice = makeSlice()

export default slice.reducer
